/* zetse — wishlist heart on the product page. Saved on this phone and listed
   on the account page (/pages/account#wishlist). */
(function () {
  var head = document.querySelector('.pdp .pdp-head');
  if (!head) return;
  var KEY = 'zetse:wishlist';
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = decodeURIComponent(m[1]);

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function has() { return read().some(function (p) { return p.handle === handle; }); }

  var css = document.createElement('style');
  css.textContent = '.pdp-head{position:relative}.z-heart{position:absolute;top:12px;right:12px;width:40px;height:40px;border-radius:50%;' +
    'border:1px solid rgba(38,42,51,.1);background:#fff;display:flex;align-items:center;justify-content:center;color:#6B7280;cursor:pointer;' +
    '-webkit-tap-highlight-color:transparent;transition:transform .12s ease}.z-heart:active{transform:scale(.9)}.z-heart.is-on{color:#E0245E}' +
    '.z-heart.is-on path{fill:currentColor}.pdp .pdp-head h1{padding-right:44px}';
  document.head.appendChild(css);

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'z-heart';
  btn.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 20s-7.5-4.6-9.2-9.5C1.6 7 3.8 4 7 4c2 0 3.5 1.2 5 3 1.5-1.8 3-3 5-3 3.2 0 5.4 3 4.2 6.5C19.5 15.4 12 20 12 20z"/></svg>';
  function paint() {
    var on = has();
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  btn.addEventListener('click', function () {
    var list = read();
    if (has()) {
      write(list.filter(function (p) { return p.handle !== handle; }));
    } else {
      var h1 = head.querySelector('h1');
      var img = document.querySelector('.pdp [data-slide] img');
      var price = head.querySelector('[data-price]');
      list.unshift({
        handle: handle,
        url: '/products/' + handle,
        title: h1 ? h1.textContent.trim() : handle,
        img: img ? img.currentSrc || img.src : '',
        price: price ? price.textContent.trim() : ''
      });
      write(list.slice(0, 100));
    }
    paint();
  });
  paint();
  head.appendChild(btn);
})();